import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { ServicingService } from '../../../../services/servicing.service';
import { AuditService } from '../../../../services/audit.service';
import { exit } from 'process';

declare var $: any;

@Component({
  selector: 'app-document_information_create',
  templateUrl: './document_information_create.component.html',
  styleUrls: ['./document_information_create.component.css']
})
export class DocumentInformationCreateComponent implements OnInit {
  @Input() mode: string;
  @Input() type: string;
  @Input() ID: string;
  @Input() langs: string;
  @Input() redirect: string;
  @Input() standard_id: string;
  @Input() chapter_id: string;
  @Input() clause_id: string;
  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  app_maintenance_plans: any;
  app_emp_id: any;
  lang: any;
  generalLang: any;
  record: any;
  imageLink: any;
  redirect1: any;
  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private servicingService: ServicingService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private auditService: AuditService,
  ) { }

  ngOnInit() {

    // this.FormBuild();
    this.getData();

    this.config();
  }


  config(): void {


    this.typeConfig = [
      { value: 'EQUIPMENT', text: 'VEHICLE' },
      { value: 'PLANT', text: 'PLANT' },
      { value: 'MACHINE', text: 'MACHINE' },
      { value: 'FIRE DISPENSER', text: 'FIRE DISPENSER' },
      { value: 'FIRST SERVICE DEVICE', text: 'FIRST SERVICE DEVICE' },
      { value: 'INDIVIDUAL PROTECTION DEVICE', text: 'INDIVIDUAL PROTECTION DEVICE' },
      { value: 'SAFETY EQUIPMENT', text: 'SAFETY EQUIPMENT' }
    ];


    this.emp_id = [
      { value: '886', text: 'demotest demotest' },
      { value: '885', text: 'dtesttest dtesttest' },
      { value: '523', text: 'PAOLO ROSSI' },
      { value: '739', text: 'Test 01' }
    ];


  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      clause_no: ['', [Validators.required]],
      clause_title: ['', [Validators.required]],
      weight: ['', [Validators.required]],
      description: ['', [Validators.required]],
      tips: ['', [Validators.required]],            
      standard_id: this.standard_id,
      chapter_id: '',
      clause_id:'',
      action: 'add_standard',
    });
  }

  FormBuildUpdate(): void {

    this.createForm.patchValue({
      clause_title: this.record.clause_title,
      clause_no: this.record.clause_no,
      weight: this.record.weight,
      description: this.record.description,
      tips: this.record.tips,
      clause_id: this.record.clause_id,
      standard_id: this.record.standard_id,
      chapter_id: this.record.chapter_id
    });


  }

  attachments(): FormArray {
    return this.createForm.get('attachments') as FormArray;
  };

  service_image_exists(): FormArray {
    return this.createForm.get('service_image_exists') as FormArray;
  };

  newAttachment1(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      link: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]]
    });
  }

  addAttachment(): void {
    this.attachments().push(this.newAttachment1());
  }

  removeAttachment(i: number) {
    this.attachments().removeAt(i);
  }


  attachments_uploaded(): FormArray {
    return this.createForm.get('attachments_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.attachments_uploaded().removeAt(i);
  }

  service_image_uploaded(): FormArray {
    return this.createForm.get('service_image_uploaded') as FormArray;
  };

  removeAttachmentUploaded1(i: number) {
    this.service_image_uploaded().removeAt(i);
  }


  public selectAttachment(event: any, index) {

    this.createForm.value.service_image_exists[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.service_image_exists[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  public selectAttachment1(event: any, index) {

    this.createForm.value.attachments[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.attachments[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }

  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }


  onSubmit() {
    // if(this.standard_id){
      this.createForm.patchValue({
        "standard_id":this.ID,
        "chapter_id":this.chapter_id
      })
    // }

    this.createFormSubmitted = true;
    if (this.createForm.invalid)
      return;
      
    this.auditService.addEditClause(this.mode,this.createForm.value).subscribe(
      res => {
        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          this.router.navigateByUrl('/test', { skipLocationChange: true })
          .then(() => {
          this.router.navigate([AppFrontRoutes.STANDARD]);
          });
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }

  getData() {

    if (this.clause_id) {
      this.auditService.getClauseInfo(this.ID,this.chapter_id,this.clause_id).subscribe(
        res => {

          if (!res.status) {
            this.generalService.notify_msg('error', 'Some problems in getting details');
            this.bsModalRef.hide();
            return;
          }
          this.record = res.data.form_data;
          this.FormBuildUpdate();
        }
      );
      this.generalLang = this.langs;
      this.redirect1 = this.redirect;
      this.modalTitle = this.type;
    }
    else {
      this.generalLang = this.langs;
      this.redirect1 = '';
      this.modalTitle = this.type;
    }

    this.createFormErrorMsg = {
      'clause_no': [{ type: 'required', message: this.generalLang.requiredField }],
      'clause_title': [{ type: 'required', message: this.generalLang.requiredField }],
      'weight': [{ type: 'required', message: this.generalLang.requiredField }],
      'description': [{ type: 'required', message: this.generalLang.requiredField }],
      'tips': [{ type: 'required', message: this.generalLang.requiredField }],
    }

    this.FormBuild();

  }

}
